import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { definePreset } from '@primeng/themes';

// "Quiet Slate" — brand blue (#2159DA) primary ramp applied to PrimeNG's
// semantic tokens so inputs, focus rings, checkboxes, paginator and selects
// all pick up the redesign palette without per-component overrides.
const QuietSlate = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#EEF3FF',
      100: '#E9F0FF',
      200: '#C7D8FA',
      300: '#9DBAF3',
      400: '#5B8AE8',
      500: '#2159DA',
      600: '#1B49B4',
      700: '#163C93',
      800: '#122F73',
      900: '#0E1B33',
      950: '#0A1526',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#2159DA',
          contrastColor: '#ffffff',
          hoverColor: '#1B49B4',
          activeColor: '#1B49B4',
        },
      },
    },
  },
});


export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([tokenInterceptor, errorInterceptor])
    ),
    // ngx-translate v17 functional API. Default language Arabic (RTL kept intact).
    provideTranslateService({
      lang: 'ar',
      fallbackLang: 'ar',
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: QuietSlate,
        options: {
          darkModeSelector: false,
        },
      },
      // Arabic (Gregorian) locale for datepicker: month/day names, labels, RTL week start.
      translation: {
        firstDayOfWeek: 6,
        dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        dayNamesShort: ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
        dayNamesMin: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: [
          'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
          'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر',
        ],
        monthNamesShort: [
          'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
          'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر',
        ],
        today: 'اليوم',
        clear: 'مسح',
        dateFormat: 'dd/mm/yy',
        weekHeader: 'أسبوع',
      },
    }),
    provideRouter(routes),
    MessageService
  ]
};
